var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTryAgain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "try again"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2761 12.1383C33.1426 3.56504 24.464 -1.65573 15.891 0.476842C11.8315 1.50744 8.33084 4.07421 6.12704 7.63596L5.41287 8.77868L4.07597 3.41363C3.8914 2.6444 3.20442 2.1014 2.41341 2.0995C1.87824 2.09975 1.3739 2.34996 1.04993 2.77596C0.725965 3.20196 0.619564 3.75484 0.762276 4.27066L3.04758 13.5552C3.23662 14.3199 3.92248 14.8573 4.71014 14.8579C4.85075 14.858 4.99082 14.8407 5.12721 14.8065L14.1027 12.5725C14.4587 12.4951 14.782 12.3095 15.0283 12.0411C15.4785 11.5378 15.5912 10.817 15.3161 10.2002C15.0411 9.58347 14.4295 9.18571 13.7542 9.18434C13.6136 9.18431 13.4736 9.20158 13.3372 9.23577L8.34378 10.4813L9.11507 9.28719C10.8404 6.54198 13.5686 4.57822 16.7194 3.81358C17.712 3.56783 18.7306 3.44313 19.7532 3.44219C25.5079 3.44081 30.5285 7.34795 31.9409 12.9269C33.3533 18.5059 30.7968 24.3316 25.7348 27.069C20.6727 29.8064 14.3983 28.7562 10.5034 24.5196C10.3777 24.3825 10.2577 24.2453 10.1377 24.1025C9.68767 23.5783 8.96685 23.3755 8.3095 23.5883L8.3095 23.5883C7.76595 23.7639 7.3456 24.1988 7.18853 24.748C7.03145 25.2972 7.15829 25.8886 7.52678 26.3251C7.67533 26.5022 7.82958 26.6736 7.98384 26.845C11.9475 31.1448 17.9413 32.9391 23.6153 31.5245C32.1881 29.3909 37.4086 20.7117 35.2761 12.1383V12.1383Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryAgain);
export default __webpack_public_path__ + "static/media/try-again.efc0e284081d8fb9f918d3b0ff9a2a36.svg";
export { ForwardRef as ReactComponent };